(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-intro"] && !Shopify.designMode) return;
  try {
    class CollectionIntro extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.collection-intro__text');
      this.toggleEl = this.querySelector('.collection-intro__toggle');
      if (!this.textEl || !this.toggleEl) return;

      this.classList.add('collection-intro--enhanced');
      this.mq = window.matchMedia('(max-width: 749px)');

      this.onToggle = () => {
        const expanded = this.getAttribute('data-expanded') === 'true';
        this.setAttribute('data-expanded', expanded ? 'false' : 'true');
        this.toggleEl.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      };
      this.update = () => {
        if (!this.mq.matches) {
          this.toggleEl.hidden = true;
          return;
        }
        const collapsed = this.getAttribute('data-expanded') !== 'true';
        this.toggleEl.hidden = collapsed && this.textEl.scrollHeight <= this.textEl.clientHeight + 1;
      };

      this.toggleEl.addEventListener('click', this.onToggle);
      this.mq.addEventListener('change', this.update);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.update);
      this.resizeObserver?.disconnect();
    }
  }

  if (!customElements.get('collection-intro')) {
    customElements.define('collection-intro', CollectionIntro);
  }
  } catch(e) { console.error(e); }
})();

})();
